import { render, staticRenderFns } from "./RouteReader.vue?vue&type=template&id=31b4cd76&"
import script from "./RouteReader.vue?vue&type=script&lang=js&"
export * from "./RouteReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports